import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Vue from 'vue'

Vue.use(Viewer)
export default {
  install (Vue) {
    Viewer.setDefaults({

      toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        oneToOne: 4,
        reset: 4,
        prev: false,//上一张
        play: {
          show: 4,
          size: 'large',
        },
        next: false,//下一张
        rotateLeft: true,
        rotateRight: true,
        flipHorizontal: true,
        flipVertical: true,
      },
      inline: false,
      fullscreen: true,
      keyboard: true,
      transition: true,
      scalable: true,

      zoomable: true,
      movable: true,
      tooltip: true,
      title: true,
      button: true
    })
  }
}

